import { useMemo, useRef, useState } from 'react'

import createContextFactory from '@/utils/factory'

const { Provider: CodeEditorProvider, useContext: useCodeEditor } = createContextFactory(() => {
  const editorsRef = useRef({})
  const [activeEditor, setActiveEditor] = useState(null)

  return useMemo(() => ({
    editorsRef,
    setEditorRef: (name, editor) => {
      editorsRef.current[name] = editor
    },
    activeEditor,
    setActiveEditor,
  }), [editorsRef, activeEditor])
})

export { CodeEditorProvider, useCodeEditor }
